exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3eqtM1rCKrkXRFW2nvPZ71 {\n    position: relative;\n}\n\n._3eqtM1rCKrkXRFW2nvPZ71:focus {\n    outline: 0;\n}\n\n._3eqtM1rCKrkXRFW2nvPZ71:focus::before {\n    border-radius: 5px;\n    bottom: 2px;\n    box-shadow: 0 0 0 2px rgb(38, 128, 235);\n    content: '';\n    left: 2px;\n    outline: 0;\n    pointer-events: none;\n    position: absolute;\n    right: 2px;\n    top: 2px;\n}\n", ""]);

// exports
exports.locals = {
	"focusRegion": "_3eqtM1rCKrkXRFW2nvPZ71"
};